import { BUSINESS_UI_STATUS, BUSINESS_UI_STATUS_LABEL } from '@/consts/businesses';

const LOCKED_UI_STATUS = [BUSINESS_UI_STATUS.IN_REVIEW, BUSINESS_UI_STATUS.REJECTED];

// Quem manda e o status, desde que o negocio volte com os dados preenchidos.
// Sem documento o cadastro esta incompleto: segue o fluxo comum, sem cadeado,
// para a Home continuar levando ao pre-cadastro.
//
// Negocio pessoal nunca trava, mesmo com uiStatus REJECTED: o backend
// conflacia billing_status BLOCKED em REJECTED (business/services/ui_status.py),
// e uma conta bloqueada nao e um negocio adicional reprovado — mostrar a tela
// de "corrigir e reenviar" pra ela e que era o bug. Espelha a mesma excecao
// que o backend ja aplica em business_is_locked() (kind != ADDITIONAL).
export const isBusinessLocked = (business) =>
  !business?.isPersonal &&
  Boolean(business?.hasDocument) &&
  LOCKED_UI_STATUS.includes(business?.uiStatus);

// O motivo vai no nome do cadeado, que entra no nome acessivel do item travado:
// a Home explica o bloqueio, mas quem navega pelo menu com leitor de tela nao
// chega nela por ele.
export const getBusinessLockReason = (business) =>
  isBusinessLocked(business)
    ? `Bloqueado: negócio ${BUSINESS_UI_STATUS_LABEL[business.uiStatus].toLowerCase()}`
    : null;

const blockNavigation = (event) => {
  event?.preventDefault?.();
  event?.stopPropagation?.();
};

// Com onClick proprio o item cai no ramo que nao usa Link, entao ele para de
// navegar e de abrir submenu. `locked` em vez de `disabled`: o disabled do MUI
// poe tabindex -1 e tira o item da ordem de Tab, e quem usa teclado nem fica
// sabendo que o menu existe. O item travado continua focavel e sai como
// aria-disabled, com o motivo no cadeado.
const lockNavItem = (item, lockIcon) => ({
  ...item,
  locked: true,
  info: lockIcon,
  onClick: blockNavigation,
  ...(item.children && { children: item.children.map((child) => lockNavItem(child, lockIcon)) }),
});

export const withLockedNavItems = (navConfig = [], lockIcon = null) =>
  navConfig.map((section) => ({
    ...section,
    items: (section.items ?? []).map((item) => lockNavItem(item, lockIcon)),
  }));

// Para onde a tela de negocio travado leva de volta. O padrao da conta vem
// primeiro porque e o mesmo negocio que o backend assume quando nenhum chega no
// header (business/middleware.py): e o "painel principal" que a pessoa conhece.
// Sem ele liberado, vale a ordem da API (padrao, aprovados, em analise,
// reprovados). O ativo nunca e destino, mesmo que a regra da trava mude: voltar
// para ele e ficar na mesma tela. Sem id tambem nao: switchBusiness ignora id
// vazio, e o botao ficaria la sem efeito.
export const getOperatingBusiness = (businesses, activeBusiness = null) => {
  const candidates = (businesses ?? []).filter(
    (business) =>
      business?.id != null &&
      String(business.id) !== String(activeBusiness?.id) &&
      !isBusinessLocked(business)
  );

  return candidates.find((business) => business.isDefault) ?? candidates[0] ?? null;
};
